module.exports = __webpack_public_path__ + "media/images/element/gallery-180884b631b2302e867122082e65421f.svg";